module.exports = __webpack_public_path__ + "assets/img/img_laojia.0a03749e.png";